import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { MDialogSelectList, MSpinner } from "components/Shared";
import { getCaseWatches, updateCaseWatches, getAvailableWatches } from "requests/watches";

const CaseWatchDialog = ({ internetUserId, controlNumber, isLenderCase, onClosed }) => {
  const [enabledWatches, setEnabledWatches] = useState(null);
  const [isFetchingEnabledWatches, setIsFetchingEnabledWatches] = useState(true);
  const [availableWatches, setAvailableWatches] = useState(null);
  const [isFetchingAvailableWatches, setIsFetchingAvailableWatches] = useState(true);
  const [dialogOptionsApplied, setDialogOptionsApplied] = useState(null);
  const mounted = useRef(true);

  useEffect(() => {
    getCaseWatches(controlNumber, internetUserId, (response) => {
      setEnabledWatches(response);
      setIsFetchingEnabledWatches(false);
    }, mounted);
    getAvailableWatches(internetUserId, (response) => {
      setAvailableWatches(response);
      setIsFetchingAvailableWatches(false);
    }, mounted);
    return () => mounted.current = false;
  }, []);

  useEffect(() => {
    if (dialogOptionsApplied) {
      onDialogOptionssApplied();
      onClosed();
    }
  }, [dialogOptionsApplied]);

  const getDialogOption = (available) => {
    return {
      checked: !!enabledWatches?.filter((enabled) => enabled.caseEventTypeId === available.id)?.length,
      label: available.name,
      value: available.id,
    };
  };

  const getDialogOptions = () => {
    return availableWatches
      ?.filter((a) => (isLenderCase && a.isAppraisalWatch) || a.isInspectionWatch)
      ?.sort((a, b) => a.displayOrder - b.displayOrder)
      ?.map(getDialogOption);
  };

  const editedDialogOptions = (editedDialogOptions) => {
    return editedDialogOptions.filter((option) => {
      let existing = enabledWatches.filter((enabled) => enabled.caseEventTypeId === option.value)[0];
      if (!existing) return option.checked;
      if (existing.checked !== option.checked) return true;
      return false;
    });
  };

  const onDialogOptionssApplied = () => {
    let edited = editedDialogOptions(dialogOptionsApplied);
    if (edited?.length) {
      saveWatches(edited);
    }
  };

  const saveWatches = (edited) => {
    updateCaseWatches(
      controlNumber,
      internetUserId,
      edited.filter((e) => e.checked).map((e) => e.value),
      edited.filter((e) => !e.checked).map((e) => e.value),
    );
  };

  if (isFetchingEnabledWatches || isFetchingAvailableWatches)
    return <MSpinner />;

  return (
    <MDialogSelectList
      title="Select Case Events to Watch"
      data={getDialogOptions() ?? []}
      onApply={setDialogOptionsApplied}
      onClose={onClosed}
      showSelectAll={true}
    />
  );
};

CaseWatchDialog.propTypes = {
  internetUserId: PropTypes.number,
  controlNumber: PropTypes.number,
  isLenderCase: PropTypes.bool,
  onClosed: PropTypes.func
};

export default CaseWatchDialog;